import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import { Guid } from '@utiljs/guid';
import { isFunction } from '@utiljs/is';
import Page from './Page';
import Jump from './Jump';
var timestamp = new Date().getTime(); // @ts-ignore

var g = new Guid(timestamp);

var preventDefault = function preventDefault(e) {
  e.preventDefault();
};

var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _super.call(this, props);

    _this.getJumpPrevPage = function () {
      return Math.max(1, _this.state.current - 5);
    };

    _this.getJumpNextPage = function () {
      return Math.min(_this.calculatePage(), _this.state.current + 5);
    };

    _this.jumpPrev = function () {
      _this.handlePageChange(_this.getJumpPrevPage());
    };

    _this.jumpNext = function () {
      _this.handlePageChange(_this.getJumpNextPage());
    };

    _this.hasPrev = function () {
      return _this.state.current > 1;
    };

    _this.hasNext = function () {
      return _this.state.current < _this.calculatePage();
    }; // 获取分页数目


    _this.calculatePage = function (p) {
      var pageSize = p;

      if (typeof pageSize === 'undefined') {
        pageSize = _this.state.pageSize;
      }

      return Math.ceil(_this.props.total / pageSize);
    }; // 上一页


    _this.handleClickPrev = function (e) {
      e.stopPropagation();

      if (_this.hasPrev()) {
        _this.handlePageChange(_this.state.current - 1);
      }
    }; // 下一页


    _this.handleClickNext = function (e) {
      e.stopPropagation();

      if (_this.hasNext()) {
        _this.handlePageChange(_this.state.current + 1);
      }
    };

    _this.handleChange = function (current) {
      var onChange = _this.props.onChange;

      if (isFunction(onChange)) {
        onChange(current);
      }
    };

    _this.handlePageChange = function (current) {
      var currentPage = _this.state.current;

      if (typeof _this.props.currentPage !== 'number') {
        if (current === currentPage) {
          return;
        }

        _this.setState({
          current: current
        }, function () {
          _this.handleChange(current);
        });

        return;
      }

      if (currentPage !== current) {
        _this.handleChange(current);
      }
    };

    _this.state = {
      current: _this.props.currentPage || _this.props.defaultCurrentPage || 1,
      pageSize: _this.props.pageSize,
      prevProps: {}
    };
    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var pagesList = [];
      var _this$state = this.state,
          current = _this$state.current,
          pageSize = _this$state.pageSize;
      var _this$props = this.props,
          total = _this$props.total,
          showJumper = _this$props.showJumper,
          size = _this$props.size,
          className = _this$props.className,
          style = _this$props.style;
      var pageBuffer = 2;
      var allPages = this.calculatePage(pageSize);
      var left = allPages > 5 ? Math.max(1, current - pageBuffer) : 1;
      var right = allPages > 5 ? Math.min(current + pageBuffer, allPages) : allPages;
      var prevClass = this.props.prevText ? 'light' : 'arrow'; // 左边跳转

      var jumpPrev = /*#__PURE__*/React.createElement("li", {
        className: "ellipsis-left",
        key: "prev",
        onClick: this.jumpPrev
      }, /*#__PURE__*/React.createElement("a", {
        onClick: preventDefault
      })); // 右边跳转

      var jumpNext = /*#__PURE__*/React.createElement("li", {
        className: "ellipsis-right",
        key: "next",
        onClick: this.jumpNext
      }, /*#__PURE__*/React.createElement("a", {
        onClick: preventDefault
      })); // 首页

      var firstPager = /*#__PURE__*/React.createElement(Page, {
        page: 1,
        onChangePage: this.handlePageChange,
        key: g.guid('pagination')
      }); // 尾页

      var lastPager = /*#__PURE__*/React.createElement(Page, {
        page: allPages,
        onChangePage: this.handlePageChange,
        key: g.guid('pagination')
      }); // 左极限

      if (current + pageBuffer >= allPages && allPages - 2 * pageBuffer >= 1) {
        left = allPages - 2 * pageBuffer;
      } // 右极限


      if (current - pageBuffer <= 1 && 1 + 2 * pageBuffer < allPages) {
        right = 1 + 2 * pageBuffer;
      }

      for (var i = left; i <= right; i++) {
        var active = current === i;
        pagesList.push( /*#__PURE__*/React.createElement(Page, {
          page: i,
          active: active,
          key: g.guid('pagination'),
          onChangePage: this.handlePageChange
        }));
      }

      if (current - pageBuffer * 2 >= 1 && allPages > 5) {
        pagesList.unshift(jumpPrev);
      }

      if (allPages - current >= pageBuffer * 2 && allPages > 5) {
        pagesList.push(jumpNext);
      }

      if (left !== 1) {
        pagesList.unshift(firstPager);
      }

      if (right !== allPages) {
        pagesList.push(lastPager);
      }

      if (total <= pageSize) {
        pagesList = /*#__PURE__*/React.createElement(Page, {
          page: 1,
          key: g.guid('pagination'),
          active: true,
          onChangePage: this.handlePageChange
        });
      }

      var clx = size === 'small' ? 'roo-pagination-sm' : 'roo-pagination';
      return /*#__PURE__*/React.createElement("ul", {
        className: classNames(clx, className),
        style: style
      }, /*#__PURE__*/React.createElement("li", {
        className: this.hasPrev() ? prevClass : 'disabled',
        onClick: this.handleClickPrev
      }, this.props.prevText ? /*#__PURE__*/React.createElement("a", {
        "aria-label": "Next",
        onClick: preventDefault
      }, this.props.prevText) : /*#__PURE__*/React.createElement("a", {
        "aria-label": "Previous"
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-chevron-left"
      })))), this.props.showPager ? pagesList : '', /*#__PURE__*/React.createElement("li", {
        className: this.hasNext() ? prevClass : 'disabled',
        onClick: this.handleClickNext
      }, this.props.nextText ? /*#__PURE__*/React.createElement("a", {
        "aria-label": "Next",
        onClick: preventDefault
      }, this.props.nextText) : /*#__PURE__*/React.createElement("a", {
        "aria-label": "Previous",
        onClick: preventDefault
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-chevron-right"
      })))), showJumper && /*#__PURE__*/React.createElement("div", {
        className: "roo-pagination-jump"
      }, /*#__PURE__*/React.createElement(Jump, {
        size: size,
        total: total,
        current: current,
        allPages: allPages,
        onChange: this.handlePageChange
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var current = prevState.current,
          pageSize = prevState.pageSize;
      var prevProps = prevState.prevProps || {};
      var controlPageSize = prevProps.pageSize !== nextProps.pageSize ? nextProps.pageSize : pageSize;
      var controlCurrentPage = prevProps.currentPage !== nextProps.currentPage ? nextProps.currentPage : current;
      var state = {
        prevProps: prevProps,
        pageSize: controlPageSize
      };

      if (nextProps.currentPage !== undefined) {
        state.current = controlCurrentPage;
      }

      return state;
    }
  }]);

  return Pagination;
}(React.Component);

Pagination.propTypes = {
  total: PropTypes.number,
  pageSize: PropTypes.number,
  currentPage: PropTypes.number,
  defaultCurrentPage: PropTypes.number,
  showPager: PropTypes.bool,
  prevText: PropTypes.string,
  nextText: PropTypes.string,
  onChange: PropTypes.func,
  showJumper: PropTypes.bool,
  size: PropTypes.string
};
Pagination.defaultProps = {
  total: 0,
  pageSize: 10,
  defaultCurrentPage: 1,
  currentPage: undefined,
  showPager: true,
  size: 'normal',
  prevText: '',
  nextText: '',
  onChange: function onChange() {},
  showJumper: false
};
polyfill(Pagination);
export default Pagination;